'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _jquery = require('jquery');

var _jquery2 = _interopRequireDefault(_jquery);

var _rpAnalytics = require('rp-analytics');

var SegmentIO = _interopRequireWildcard(_rpAnalytics);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var PopOver = function () {
    function PopOver(popOverConfig) {
        _classCallCheck(this, PopOver);

        var defaultConfig = {
            popOverSelector: '.js-popOver',
            openAreaSelectors: ['.js-popOver__openArea'],
            toggleAreaSelector: '.js-popOver__toggleArea',
            closeAreaSelectors: ['.js-popOver__shadow', '.js-popOver__closeBtn'],
            activeClass: 'ui-popOver_active',
            onOpen: null,
            onClose: null,
            name: ''
        };
        this.config = _jquery2.default.extend(true, defaultConfig, popOverConfig);
        this.init();
    }

    _createClass(PopOver, [{
        key: 'init',
        value: function init() {
            this.popOver = (0, _jquery2.default)(this.config.popOverSelector)[0];
            this.openArea = (0, _jquery2.default)(this.config.openAreaSelectors.join(','));
            this.toggleArea = (0, _jquery2.default)(this.config.toggleAreaSelector)[0];
            this.closeArea = (0, _jquery2.default)(this.config.closeAreaSelectors.join(','));

            this.bindEvents();
        }
    }, {
        key: 'bindEvents',
        value: function bindEvents() {
            var _this = this;

            Array.prototype.forEach.call(this.openArea, function (element) {
                return element.addEventListener('click', function (e) {
                    _this.onOpenAreaClicked(e);
                }, false);
            });

            if (this.toggleArea) {
                this.toggleArea.addEventListener('click', function (e) {
                    _this.onTogglePopOver(e);
                }, false);
            }

            Array.prototype.forEach.call(this.closeArea, function (element) {
                return element.addEventListener('click', function (e) {
                    _this.onCloseAreaClicked(e);
                }, false);
            });
        }
    }, {
        key: 'onOpenAreaClicked',
        value: function onOpenAreaClicked(event) {
            event.preventDefault();
            this.open(event);

            // Note:
            // This is a solution for the re-rendering
            // If we don't remove the click event listener first,
            // multiple Segment events will trigger due to re-rendering
            (0, _jquery2.default)('.PC-bestOdds__bookieRow__name_account.ui-link').off('click');
            (0, _jquery2.default)('.PC-bestOdds__bookieRow__name_account.ui-link').on('click', function () {
                var _SegmentIO$trackBookm;

                var bookmakerNode = (0, _jquery2.default)('.PC-bestOdds__bookieRow:hover');
                var bookmakerNameFound = bookmakerNode.find('.PC-bestOdds__bookieRow__name > div').text().trim();
                var bookmakerName = bookmakerNameFound === 'Sky bet' ? 'SkyBet' : bookmakerNameFound;
                var bookmakerPosition = Number(Number((0, _jquery2.default)('.PC-bestOdds__bookieRow:hover').css('order')) + 1);

                SegmentIO.trackBookmakerRegistrationTap((_SegmentIO$trackBookm = {}, _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_BOOKMAKER_NAME, bookmakerName), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_OFFERS_BANNER, null), _defineProperty(_SegmentIO$trackBookm, SegmentIO.TRAIT_POSITION, bookmakerPosition), _SegmentIO$trackBookm));
            });
        }
    }, {
        key: 'onTogglePopOver',
        value: function onTogglePopOver(event) {
            event.preventDefault();
            this.toggle();
        }
    }, {
        key: 'onCloseAreaClicked',
        value: function onCloseAreaClicked(event) {
            (0, _jquery2.default)('.PC-bestOdds__bookieRow__name_account.ui-link').off('click');

            this.close(event);
        }
    }, {
        key: 'destroy',
        value: function destroy() {
            var _this2 = this;

            Array.prototype.forEach.call(this.openArea, function (element) {
                element.removeEventListener('click', function (e) {
                    _this2.onOpenAreaClicked(e);
                }, false);
            });

            if (this.toggleArea) {
                this.toggleArea.removeEventListener('click', function (e) {
                    _this2.onTogglePopOver(e);
                }, false);
            }

            Array.prototype.forEach.call(this.closeArea, function (element) {
                element.removeEventListener('click', function (e) {
                    _this2.onCloseAreaClicked(e);
                }, false);
            });
        }
    }, {
        key: 'toggle',
        value: function toggle() {
            if (this.isActive()) {
                this.close();
            } else {
                this.open();
            }
        }
    }, {
        key: 'open',
        value: function open(event) {
            if (this.popOver) {
                this.popOver.classList.add(this.config.activeClass);
            }

            if (this.config.onOpen instanceof Function) {
                this.config.onOpen(event);
            }

            _jquery2.default.event.trigger('popoverOpened' + this.config.name);
        }
    }, {
        key: 'close',
        value: function close() {
            if (this.config.onClose instanceof Function) {
                this.config.onClose();
            }

            if (this.popOver) {
                this.popOver.classList.remove(this.config.activeClass);
            }

            _jquery2.default.event.trigger('popoverClosed' + this.config.name);
        }
    }, {
        key: 'isActive',
        value: function isActive() {
            return this.popOver.classList.contains(this.config.activeClass);
        }
    }]);

    return PopOver;
}();

exports.default = PopOver;


//////////////////
// WEBPACK FOOTER
// ./~/rp-prices-component/lib/js/utils/PopOver.js
// module id = 999
// module chunks = 0